export const GET_CONNECTIONS = 'GET_CONNECTIONS';
export const SELECTED_CONNECTION = 'SELECTED_CONNECTION';
export const GET_PROVIDER_ACCOUNTS = 'GET_PROVIDER_ACCOUNTS';
export const GET_ACCOUNT_TYPES = 'GET_ACCOUNT_TYPES';
export const IS_ACCOUNTS_LOADED = 'IS_ACCOUNTS_LOADED';
export const ACCOUNT_TYPE_LOADED = 'ACCOUNT_TYPE_LOADED';
export const GET_AGREEMENTS = 'GET_AGREEMENTS';
export const UPDATE_CURRENT_ACCOUNT_TYPE = 'UPDATE_CURRENT_ACCOUNT_TYPE';
export const UPDATE_CONNECTION_TYPE = 'UPDATE_CONNECTION_TYPE';
export const SAVE_CONNECTIONS = 'SAVE_CONNECTIONS';
export const GET_SHIPPER_CODES = 'GET_SHIPPER_CODES';
export const GET_SHIPPER_IDENTIFIERS = 'GET_SHIPPER_IDENTIFIERS';
export const SET_DATASOURCE = 'SET_DATASOURCE';
export const SET_NEW_AGREEMENTS = 'SET_NEW_AGREEMENTS';
export const SET_SELECTED_SHIPPER = 'SET_SELECTED_SHIPPER';
export const ADD_SHIPMENT_IDENTIFIER = 'ADD_SHIPMENT_IDENTIFIER';
export const RESET_AGREEMENT_LIST = 'RESET_AGREEMENT_LIST';
export const SET_NEW_TRUCK_AGREEMENT = 'SET_NEW_TRUCK_AGREEMENT';
export const DISPLAY_SNACKBAR = 'DISPLAY_SNACKBAR';
export const REMOVE_TEMP_SHIPPER_CODES = 'REMOVE_TEMP_SHIPPER_CODES';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const CLEAR_REQUEST = 'CLEAR_REQUEST';
export const CHANGE_REQUEST = 'CHANGE_REQUEST';
export const CLEAR_PROVIDER = 'CLEAR_PROVIDER';
export const UPDATE_AGREEMENT = 'UPDATE_AGREEMENT';
export const FILTER_CONNECTIONS = 'FILTER_CONNECTIONS';
export const GET_GROUPNAMES = 'GET_GROUPNAMES';
export const SET_SORT_ORDER = 'SET_SORT_ORDER';
export const SET_SORT_FIELD = 'SET_SORT_FIELD';
export const ENABLE_GETCONNECTION_OPERATIONS = 'ENABLE_GETCONNECTION_OPERATIONS';
export const DISABLE_GETCONNECTION_OPERATIONS = 'DISABLE_GETCONNECTION_OPERATIONS';
export const DISABLE_CONNECTION_STATUS_OPERATIONS = 'DISABLE_CONNECTION_STATUS_OPERATIONS';
export const ENABLE_CONNECTION_STATUS_OPERATIONS = 'ENABLE_CONNECTION_STATUS_OPERATIONS';
export const GET_CONNECTION_AGREEMENTS = 'GET_CONNECTION_AGREEMENTS';
export const GET_V2_CONNECTION_AGREEMENTS = 'GET_V2_CONNECTION_AGREEMENTS';
export const RESET_V2_CONNECTION_AGREEMENTS = 'RESET_V2_CONNECTION_AGREEMENTS';
export const GET_V2_PROVIDER_SUMMARY = 'GET_V2_PROVIDER_SUMMARY';
export const GET_V2_SHARING_AGREEMENTS = 'GET_V2_SHARING_AGREEMENTS';
export const SAVE_AGREEMENTS = 'SAVE_AGREEMENTS';
export const SHOW_TABLE = 'SHOW_TABLE';
export const HIDE_TABLE = 'HIDE_TABLE';
export const GET_MOBILITY_DATA = 'GET_MOBILITY_DATA';
export const SET_PROVIDER = 'SET_PROVIDER';
export const SET_CURRENT_GROUP = 'SET_CURRENT_GROUP';
export const ADD_NEW_SHIPPER = 'ADD_NEW_SHIPPER';
export const REMOVE_SHIPPER = 'REMOVE_SHIPPER';
export const RESET_SELECTED_DATASOURCE = 'RESET_SELECTED_DATASOURCE';
export const SET_SELECTED_DATASOURCE = 'SET_SELECTED_DATASOURCE';
export const SHOW_ADD_SHIPPER = 'SHOW_ADD_SHIPPER';
export const HIDE_ADD_SHIPPER = 'HIDE_ADD_SHIPPER';
export const CLEAR_SHIPPER = 'CLEAR_SHIPPER';
export const SHOW_ADD_TRUCK = 'SHOW_ADD_TRUCK';
export const HIDE_ADD_TRUCK = 'HIDE_ADD_TRUCK';
export const ADD_NEW_TRUCK = 'ADD_NEW_TRUCK';
export const REMOVE_TRUCK = 'REMOVE_TRUCK';
export const CLEAR_TRUCK = 'CLEAR_TRUCK';
export const UPDATE_TRUCK = 'UPDATE_TRUCK';
export const GET_GROUP_AGREEMENTS = 'GET_GROUP_AGREEMENTS';
export const UPDATE_NEW_AGREEMENT = 'UPDATE_NEW_AGREEMENT';
export const CHANGE_CONNECTIONS = 'CHANGE_CONNECTIONS';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const SET_SELECTED_DATASOURCE_AGREEMENT = 'SET_SELECTED_DATASOURCE_AGREEMENT';
export const TOGGLE_SPINNER = 'TOGGLE_SPINNER';
export const SET_FROM_CREATE_FLOW = 'SET_FROM_CREATE_FLOW';
export const HIDE_SPINNER = 'HIDE_SPINNER';
export const RESET_SEARCH_TEXT = 'RESET_SEARCH_TEXT';
export const UPDATE_TRUCK_AGREEMENT = 'UPDATE_TRUCK_AGREEMENT';
export const CLEAR_TRUCK_AGREEMENT = 'CLEAR_TRUCK_AGREEMENT';
export const UPDATE_SEARCH_TEXT = 'UPDATE_SEARCH_TEXT';
export const RESET_AGREEMENTS = 'RESET_AGREEMENTS';
export const IS_EMPTY_AGREEMENTS = 'IS_EMPTY_AGREEMENTS';
export const IS_TITAN_SERVICE_ENABLED = 'IS_TITAN_SERVICE_ENABLED';
export const SET_CLOUD_HUB_CONNECTOR_STATUS = 'SET_CLOUD_HUB_CONNECTOR_STATUS';
export const FETCH_CLOUD_HUB_CONNECTOR_STATUS = 'FETCH_CLOUD_HUB_CONNECTOR_STATUS';
export const SET_CLOUD_HUB_CONNECTOR_STATUS_ERROR = 'SET_CLOUD_HUB_CONNECTOR_STATUS_ERROR';
export const ADD_PROVIDER_ID = 'ADD_PROVIDER_ID';
export const DISABLE_CONNECTION_OPERATIONS = 'DISABLE_CONNECTION_OPERATIONS';
export const DISABLE_AGREEMENT_OPERATIONS = 'DISABLE_AGREEMENT_OPERATIONS';
export const ENABLE_CONNECTION_OPERATIONS = 'ENABLE_CONNECTION_OPERATIONS';
export const ENABLE_AGREEMENT_OPERATIONS = 'ENABLE_AGREEMENT_OPERATIONS';
export const TRUCK_DATA_LOADED = 'TRUCK_DATA_LOADED';
export const SHIPPER_CODES_LOADED = 'SHIPPER_CODES_LOADED';
export const SET_DATASOURCE_CHECKCALLTYPE = 'SET_DATASOURCE_CHECKCALLTYPE';
export const CHECK_CALL_UPDATE_FLAG = 'CHECK_CALL_UPDATE_FLAG';
export const CHECK_CALL_DELAY_FLAG = 'CHECK_CALL_DELAY_FLAG';
export const CLEAR_CHECK_CALL_DATA = 'CLEAR_CHECK_CALL_DATA';
export const CHECK_CALL_FETCH_FLAG = 'CHECK_CALL_FETCH_FLAG';
export const SET_SELECTED_GROUP_NAME = 'SET_SELECTED_GROUP_NAME';
export const AGREEMENT_CURRENT_OPERATION = 'AGREEMENT_CURRENT_OPERATION';
export const CONNECTION_CURRENT_OPERATION = 'CONNECTION_CURRENT_OPERATION';
export const CLEAR_GROUPNAMES = 'CLEAR_GROUPNAMES';
export const SHIPPER_GROUP_LOADED = 'SHIPPER_GROUP_LOADED';
export const SHOW_AGREEMENTS = 'SHOW_AGREEMENTS';
export const HIDE_AGREEMENTS = 'HIDE_AGREEMENTS';
export const TOGGLE_EVENTS_LOADED = 'TOGGLE_EVENTS_LOADED';

export const CREATE_NEW_CONNECTION = 'CREATE_NEW_CONNECTION';
export const ADD_NEW_SHIPMENT_AGREEMENT = 'ADD_NEW_SHIPMENT_AGREEMENT';
export const UPDATE_NEW_SHIPMENT_AGREEMENT = 'UPDATE_NEW_SHIPMENT_AGREEMENT';
export const ADD_NEW_TRUCK_AGREEMENT = 'ADD_NEW_TRUCK_AGREEMENT';
export const UPDATE_NEW_TRUCK_AGREEMENT = 'UPDATE_NEW_TRUCK_AGREEMENT';
export const UPDATE_NEW_AGREEMENT_GROUP = 'UPDATE_NEW_AGREEMENT_GROUP';
export const GET_SELECTED_PROVIDER_DETAILS = 'GET_SELECTED_PROVIDER_DETAILS';
export const GET_SELECTED_DATA_SOURCE = 'GET_SELECTED_DATA_SOURCE';
export const TOGGLE_SHOW_CREATE_CONNECTION = 'TOGGLE_SHOW_CREATE_CONNECTION';
export const AGREEMENT_SAVE_FLAG = 'AGREEMENT_SAVE_FLAG';
export const STORE_NEW_CONNECTION_ID = 'STORE_NEW_CONNECTION_ID';
export const UPDATE_EDIT_EXISTING_SHIPMENT_AGREEMENT = 'UPDATE_EDIT_EXISTING_SHIPMENT_AGREEMENT';
export const UPDATE_FILTERED_AGREEMENTS = 'UPDATE_FILTERED_AGREEMENTS';
export const UPDATE_EXISTING_AGREEMENT_GROUP = 'UPDATE_EXISTING_AGREEMENT_GROUP';
export const UPDATE_DELETED_AGREEMENTS = 'UPDATE_DELETED_AGREEMENTS';
export const CHECK_CLEAR_EDITED_AGREEMENTS = 'CHECK_CLEAR_EDITED_AGREEMENTS';
export const OPEN_GROUP = 'OPEN_GROUP';
export const TOGGLE_AGREEMENT_EDIT_MODE = 'TOGGLE_AGREEMENT_EDIT_MODE';
export const DISCARD_CHANGES = 'DISCARD_CHANGES';
export const TOGGLE_PROVIDER_CONNECTION_LOADED = 'TOGGLE_PROVIDER_CONNECTION_LOADED';
export const GET_TIMEZONES = 'GET_TIMEZONES';
export const SET_CLOSE_ALL_PANEL = 'SET_CLOSE_ALL_PANEL';
export const UPDATE_SELECTED_ACCOUNT_TYPE = 'UPDATE_SELECTED_ACCOUNT_TYPE';
export const GET_TRUSTCENTER_EVENT_TYPES = 'GET_TRUSTCENTER_EVENT_TYPES';
export const ADD_CARRIER_CONFIG = 'ADD_CARRIER_CONFIG';
export const ADD_SHIPPER_CONFIG = 'ADD_SHIPPER_CONFIG';
export const ADD_ALL_SHIPPER_CONFIG = 'ADD_ALL_SHIPPER_CONFIG';
export const GET_SHIPPER_CONFIG = 'GET_SHIPPER_CONFIG';
export const CARRIER_CONFIG_EXIST = 'CARRIER_CONFIG_EXIST';
export const RESET_CARRIER_CONFIG_EXIST = 'RESET_CARRIER_CONFIG_EXIST';
export const MACROPOINT = 'MacroPoint';
export const MACROPOINT_NAME = 'macropointId';
export const UPDATE_V2_SHARING_AGREEMENT = 'UPDATE_V2_SHARING_AGREEMENT';
export const ADD_V2_SHARING_AGREEMENT = 'ADD_V2_SHARING_AGREEMENT';
export const GET_V2_PROVIDER_CONFIG = 'GET_V2_PROVIDER_CONFIG';
export const SET_SELECTED_V2_SHARING_AGREEMENT = 'SET_SELECTED_V2_SHARING_AGREEMENT';
